import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_DANHSACHKHACHHANG } from "actions/DanhSachKhachHang/actionTypes";
import {
  getListDanhSachKhachHangSuccess,
  getListDanhSachKhachHangFailure,
} from "actions/DanhSachKhachHang";
import DanhSachKhachHangApi from "service/danhSachKhachHangApi";
import { pushNotification } from "utils/notifications";

function* getListDanhSachKhachHang(action) {
  try {
    const response = yield call(DanhSachKhachHangApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListDanhSachKhachHangSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListDanhSachKhachHangFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListDanhSachKhachHangFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_DANHSACHKHACHHANG, getListDanhSachKhachHang);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
